<template lang='pug'>
  header(class='c-header')
    //- div(class='u-flex u-justify-end o-container u-show@laptop' v-if='white')
      ul(class='u-flex u-mb0 u-justify-end u-items-center u-list-none')
        li(class='u-fw-s-bold u-white u-mr3')
          i(class='u-icon u-color-secondary u-mr2') phone
          span(class='') 052-310909 | 052-311616
        li(class='u-fw-s-bold u-white')
          i(class='u-icon u-color-secondary u-mr2') cellphone
          span(class='') #952979722 | 952386565 | 952637400
      ul(class='u-flex u-mb0')
        button(class='c-btn-share c-btn-share--facebook')
          i(class='u-icon') facebook
        button(class='c-btn-share c-btn-share--linkedin')
          i(class='u-icon') linkedin
        button(class='c-btn-share c-btn-share--instagram')
          i(class='u-icon') instagram
        button(class='c-btn-share c-btn-share--google')
          i(class='u-icon') youtube
        button(class='c-btn-share c-btn-share--soundcloud')
          i(class='u-icon') soundcloud
        button(class='c-btn-share c-btn-share--vimeo')
          i(class='u-icon') vimeo


    div(class='u-relative')
      headroom(class='c-header__wrapper o-container', :class="[{'c-header--white' : white}, wrapperClass]")
        router-link(:to="{ name: 'Home'}" class='c-header__logo')
          img(:src='company.logoUrl' v-if='!white' class='')
          img(:src='company.whiteLogoUrl' v-if='white' class='')

        div(class='u-flex u-items-center')
          ul(class='u-list-none  u-pl0 u-flex u-items-center u-mt0 u-mb0 u-show@laptop')
            li(class='u-mr3 u-py2 c-dropdown u-relative')
              a(class='c-header__link') Trabaja con nosotros
              ul(class='c-dropdown__content')
                li()
                  router-link(:to="{ name: 'Driver'}" class='c-dropdown__item') Conductor
                li(class='c-dropdown__item')
                  router-link(:to="{ name: 'Operator'}" class='c-dropdown__item') Radio Operadora
            li(class='u-mx3 u-py2')
              router-link(:to="{ name: 'Services'}" class='c-header__link') Servicios
            li(class='u-mx3 u-py2')
              router-link(:to="{ name: 'About'}" class='c-header__link') Nosotros
            li(class='u-mx3 u-py2')
              router-link(:to="{ name: 'Posts'}" class='c-header__link') Noticias
            li(class='u-ml3 u-mr2 u-py2')
              router-link(:to="{ name: 'Contact'}" class='c-header__link') Contáctanos
            li(class='u-mr4 u-ml2 u-pl3 u-uppercase u-fw-bold u-border-left u-border-text')
              router-link(:to="{ name: 'Reserve'}" class='c-header__link u-pt0 u-pb0') Reserva Ya!

          router-link(:to="{ name: 'App'}"
            class='u-flex u-items-center c-btn--secondary u-fz-h6 u-uppercase u-uppercase u-fw-s-bold u-px4 u-show@tablet u-decoration-none') Descargar App
          //- button(class='c-btn--secondary u-uppercase u-uppercase u-fw-s-bold u-px4') Descargar App

          button(class='u-flex u-fz-h3 u-items-center c-header__btn u-ml3', @click='isHeaderResponsive = true')
            i(class='u-icon') menu
    app-header-responsive(v-if='isHeaderResponsive' @hide='isHeaderResponsive = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import AppHeaderResponsive from './AppHeaderResponsive'

  export default {
    components: { AppHeaderResponsive },
    props: {
      wrapperClass: String,
      white: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        isShowCart: false,
        isHeaderResponsive: false,
        swiperItems: {
          slidesPerView: 6,
          spaceBetween: 30,
          breakpoints: {
            458: {
              slidesPerView: 1
            },
            620: {
              slidesPerView: 2
            },
            889: {
              slidesPerView: 3
            },
            998: {
              slidesPerView: 4
            },
            1099: {
              slidesPerView: 5
            }
          }
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    mounted () {
      // window.$('.c-header__wrapper').headroom()
    },

    watch: {
      '$route' () {
        this.isHeaderResponsive = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppHeader.vue